import { render, staticRenderFns } from "./HomeAccess.vue?vue&type=template&id=4622484c&scoped=true"
import script from "./HomeAccess.vue?vue&type=script&lang=js"
export * from "./HomeAccess.vue?vue&type=script&lang=js"
import style0 from "./HomeAccess.vue?vue&type=style&index=0&id=4622484c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622484c",
  null
  
)

export default component.exports